import { render, staticRenderFns } from "./AdminRedirect.vue?vue&type=template&id=7873394d&scoped=true"
import script from "./AdminRedirect.vue?vue&type=script&lang=js"
export * from "./AdminRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7873394d",
  null
  
)

export default component.exports